import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Events from './pages/Events'
import Archive from './pages/Archive'
import ClergyAdmin from './pages/Clergy'
import Deaneries from './pages/Deaneries'
import TemplesAdmin from './pages/Temples'
import NewsAdmin from './pages/News'
import Galleries from './pages/Galleries'
import VideosAdmin from './pages/Videos'
import Settings from './pages/Settings'
import NecropolisAdmin from './pages/Necropolis'
import SchedulesAdmin from './pages/Schedules'
import FeastsAdmin from './pages/Feasts'
import SaintsAdmin from './pages/Saints'
import DocumentsAdmin from './pages/Documents'
import NewspapersAdmin from './pages/Newspapers'

function App() {
  const { isAuthenticated } = useAuth()

  // Not authenticated - show login
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    )
  }

  // Authenticated - show admin panel
  return (
    <Layout>
      <Routes>
        {/* Paths are relative to the router basename="/admin" (main.tsx) — do NOT
            repeat the /admin prefix here, or every URL becomes /admin/admin/... */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/events" element={<Events />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/clergy" element={<ClergyAdmin />} />
        <Route path="/deaneries" element={<Deaneries />} />
        <Route path="/temples" element={<TemplesAdmin />} />
        <Route path="/news" element={<NewsAdmin />} />
        <Route path="/galleries" element={<Galleries />} />
        <Route path="/videos" element={<VideosAdmin />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/necropolis" element={<NecropolisAdmin />} />
        <Route path="/schedules" element={<SchedulesAdmin />} />
        <Route path="/feasts" element={<FeastsAdmin />} />
        <Route path="/saints" element={<SaintsAdmin />} />
        <Route path="/documents" element={<DocumentsAdmin />} />
        <Route path="/newspapers" element={<NewspapersAdmin />} />
        {/* Legacy double-prefixed URLs (/admin/admin/*) that users may have bookmarked */}
        <Route path="/admin/*" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  )
}

export default App